import { PagePending } from "@/components/ui/PagePending";
import { PageWrapper } from "@/components/ui/PageWrapper";
import { TabNav, TabNavItem } from "@/components/ui/TabNav";
import { Box, Flex } from "@givenwell/components";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/supporter/$supporterId/financial-reports")({
  pendingComponent: PagePending,
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PageWrapper maxWidth={1400} title="Billing">
      <Flex css={{ flexDirection: "column", gap: 16 }}>
        <TabNav>
          <TabNavItem from="/supporter/$supporterId/financial-reports" to="./invoices">
            Invoices
          </TabNavItem>
          <TabNavItem from="/supporter/$supporterId/financial-reports" to="./transactions">
            Transactions
          </TabNavItem>
        </TabNav>
        <Box css={{ flex: "1 0 0px" }}>
          <Outlet />
        </Box>
      </Flex>
    </PageWrapper>
  );
}
